export default __webpack_public_path__ + "static/media/org-arrow.61edf718.svg";